import { createContext } from 'react';
export var CianNewbuildingChatButtonContext = /*#__PURE__*/createContext({
  builders: [],
  sellers: []
});